import {
  HttpClient,
  HttpClientModule,
  HTTP_INTERCEPTORS,
} from '@angular/common/http';
// import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './shared/components/header/header.component';
import { NotFoundComponent } from './shared/components/not-found/not-found.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
  CommonModule,
  NgOptimizedImage,
  registerLocaleData,
} from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxGanttModule } from '@worktile/gantt';
import { GANTT_GLOBAL_CONFIG } from '@worktile/gantt';
import { setDefaultOptions } from 'date-fns';
import { ru } from 'date-fns/locale';
import { ApplyTokenInterceptor } from 'Core/interceptors/apply-token.interceptor';
import { RefreshTokenInterceptor } from 'Core/interceptors/refresh-token.interceptor';
import {
  APP_INITIALIZER,
  DEFAULT_CURRENCY_CODE,
  ErrorHandler,
  LOCALE_ID,
  NgModule,
} from '@angular/core';
import localeRu from '@angular/common/locales/ru';
import { CarouselModule } from 'primeng/carousel';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { MenubarModule } from 'primeng/menubar';
import { SidebarModule } from 'primeng/sidebar';
import { ButtonModule } from 'primeng/button';
import { MenuModule } from 'primeng/menu';
import { BadgeModule } from 'primeng/badge';
import { CalendarModule } from 'primeng/calendar';
import { GalleriaModule } from 'primeng/galleria';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { environment } from 'Env';
import { ENVIRONMENT } from 'Core/services/environment.service';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { register } from 'swiper/element/bundle';
import { LoaderInterceptorService } from 'Core/interceptors/loader.interceptor';
import * as Sentry from '@sentry/angular-ivy';
import { Router } from '@angular/router';
import { GlobalErrorHandler } from 'Core/error-handlers/GlobalErrorHandler';
import { NgxCaptchaModule } from 'ngx-captcha';

register();

setDefaultOptions({ locale: ru });

export function createTranslateLoader(http: HttpClient) {
  // @ts-ignore
  return new TranslateHttpLoader(
    http,
    './assets/i18n/',
    '.json?from=' + new Date().getTime(),
  );
}

// AoT requires an exported function for factories
export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient);
}

registerLocaleData(localeRu);

@NgModule({
  declarations: [AppComponent, HeaderComponent, NotFoundComponent],
  imports: [
    GalleriaModule,
    NgxUiLoaderModule.forRoot({}),
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgxGanttModule,
    CarouselModule,
    ToastModule,
    MenubarModule,
    SidebarModule,
    ButtonModule,
    MenuModule,
    BadgeModule,
    CalendarModule,
    NgxMaskDirective,
    NgxMaskPipe,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    NgOptimizedImage,
    NgxCaptchaModule,
  ],
  providers: [
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: false,
      }),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      deps: [Sentry.TraceService],
      multi: true,
    },
    MessageService,
    { provide: LOCALE_ID, useValue: 'ru' },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApplyTokenInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RefreshTokenInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoaderInterceptorService,
      multi: true,
    },
    {
      provide: GANTT_GLOBAL_CONFIG,
      useValue: {
        dateFormat: {
          yearQuarter: `QQQ 'of' yyyy`,
          month: 'LLLL',
          yearMonth: `LLLL yyyy'(week' w ')'`,
        },
      },
    },
    { provide: ENVIRONMENT, useValue: environment },
    { provide: DEFAULT_CURRENCY_CODE, useValue: 'RUB' },
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    provideNgxMask(),
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
